import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Default",
    redirect: { name: "Summary" },
  },
  {
    path: "/invoice/:pageid",
    name: "Invoice",
    component: () => import(/* webpackChunkName: "Invoice" */ "../views/Invoice.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import(/* webpackChunkName: "Login" */ "../views/Login.vue"),
  },
  {
    path: "/orders",
    name: "Orders",
    component: () => import(/* webpackChunkName: "Orders" */ "../views/Orders.vue"),
  },
  {
    path: "/products",
    name: "Products",
    component: () => import(/* webpackChunkName: "Products" */ "../views/Products.vue"),
  },
  {
    path: "/summary",
    name: "Summary",
    component: () => import(/* webpackChunkName: "Summary" */ "../views/Summary.vue"),
  },
  {
    path: "/404",
    name: "404",
    component: () => import(/* webpackChunkName: "404" */ "../views/404.vue"),
  },
  {
    path: "*",
    name: "Home",
    component: Home,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  /* must call `next` */
  if (!["Login", "Invoice"].includes(to.name) && !store.state.user.isLoggedIn)
    next({ name: "Login" });
  else next();
});

export default router;
